import apolloClient from '../../utils/apollo-client';
import { quickQuote } from '../graphql/quote';

export default async function getFinance(payLoad) {
  const response = await apolloClient().then((client) =>
    client.query({
      query: quickQuote,
      variables: { payLoad: payLoad },
      fetchPolicy: 'no-cache',
    })
  );
  return response.data.quickQuote;
}
